import { env } from "configs/EnvironmentConfig";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const API_ERROR = "LOGIN_API_ERROR";
export const AUTH_TOKEN = "authUser" + env.API_AIR_BRAKE_ENV;
export const SESSION_KEY = "sessionKey" + env.API_AIR_BRAKE_ENV;
export const REFRESH_TOKEN = "refreshToken" + env.API_AIR_BRAKE_ENV;
export const FORCE_CHANGE_PASS = "forceChangePass" + env.API_AIR_BRAKE_ENV;

export const SOCIAL_LOGIN = "SOCIAL_LOGIN";
export const USER_INFO = "userInfo";
export const TENANT_CODE_HEADER = "TENANT_CODE_HEADER";
export const BU_TENANT_HEADER = "BU_TENANT_HEADER";
export const BU_STORE_HEADER = "BU_STORE_HEADER";

export const ROLE_ADMIN = "ROLE_SUPER_ADMIN";
export const ROLE_EINVOICE_ADMIN = "ROLE_EINVOICE_ADMIN";
export const ROLE_APP_ADMIN = "ROLE_APP_ADMIN";
export const ROLE_SUPERVISOR = "ROLE_SUPERVISOR";
export const ROLE_ACCOUNTANT = "ROLE_ACCOUNTANT";

export const ROLE_EINVOICE_CUA_HANG = "ROLE_EINVOICE_CUA_HANG";
export const ROLE_EINVOICE_KE_TOAN = "ROLE_EINVOICE_KE_TOAN";
export const ROLE_VIEW_ORIGINAl_PDF = "ROLE_EINVOICE_NONE_COPY_PDF";
export const ROLE_EINVOICE_CONTINUE_SEND_MAIL =
  "ROLE_EINVOICE_CONTINUE_SEND_MAIL";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";
